// FETCH ALL SIZE INFO
export const FETCH_SIZE_INFO_REQUEST = 'FETCH_SIZE_INFO_REQUEST';
export const FETCH_SIZE_INFO_SUCCESS = 'FETCH_SIZE_INFO_SUCCESS';
export const FETCH_SIZE_INFO_FAILURE = 'FETCH_SIZE_INFO_FAILURE';

// CREATE SIZE INFO
export const CREATE_SIZE_INFO_REQUEST = 'CREATE_SIZE_INFO_REQUEST';
export const CREATE_SIZE_INFO_SUCCESS = 'CREATE_SIZE_INFO_SUCCESS';
export const CREATE_SIZE_INFO_FAILURE = 'CREATE_SIZE_INFO_FAILURE';

// UPDATE SIZE INFO
export const UPDATE_SIZE_INFO_REQUEST = 'UPDATE_SIZE_INFO_REQUEST';
export const UPDATE_SIZE_INFO_SUCCESS = 'UPDATE_SIZE_INFO_SUCCESS';
export const UPDATE_SIZE_INFO_FAILURE = 'UPDATE_SIZE_INFO_FAILURE';

// FETCH SINGLE STATE OF SIZE INFO
export const FETCH_SINGLE_SIZE_INFO_REQUEST = 'FETCH_SINGLE_SIZE_INFO_REQUEST';
export const FETCH_SINGLE_SIZE_INFO_SUCCESS = 'FETCH_SINGLE_SIZE_INFO_SUCCESS';
export const FETCH_SINGLE_SIZE_INFO_FAILURE = 'FETCH_SINGLE_SIZE_INFO_FAILURE';

// DELETE SIZE INFO
export const DELETE_SIZE_INFO_REQUEST = 'DELETE_SIZE_INFO_REQUEST';
export const DELETE_SIZE_INFO_SUCCESS = 'DELETE_SIZE_INFO_SUCCESS';
export const DELETE_SIZE_INFO_FAILURE = 'DELETE_SIZE_INFO_FAILURE';

// FETCH GENDER
export const FETCH_GENDER_REQUEST = 'FETCH_GENDER_REQUEST';
export const FETCH_GENDER_SUCCESS = 'FETCH_GENDER_SUCCESS';
export const FETCH_GENDER_FAILURE = 'FETCH_GENDER_FAILURE';

export const RESET_SIZE_INFO_INFO = 'RESET_SIZE_INFO_INFO';

export const CREATE_SIZE_INFO_FORM = 'CREATE_SIZE_INFO_FORM';

export const UPDATE_SIZE_INFO_FORM = 'UPDATE_SIZE_INFO_FORM';


// NAVIGATE TO SIZE RATIO COMPONENT
export const NAVIGATE_SIZE_RATIO = 'NAVIGATE_SIZE_RATIO';
export const NAVIGATE_SIZE_RATIO_MEASUREMENT = 'NAVIGATE_SIZE_RATIO_MEASUREMENT';


// NAVIGATE TO SIZE INFO COMPONENT
export const NAVIGATE_SIZE_INFO = 'NAVIGATE_SIZE_INFO';


//FETCH INVOICE DATA
export const FETCH_SIZE_INFO_INVOICE_REQUEST = 'FETCH_SIZE_INFO_INVOICE_REQUEST';
export const FETCH_SIZE_INFO_INVOICE_SUCCESS = 'FETCH_SIZE_INFO_INVOICE_SUCCESS';
export const FETCH_SIZE_INFO_INVOICE_FAILURE = 'FETCH_SIZE_INFO_INVOICE_FAILURE';

export const RESET_SIZE_INFO_INVOICE = 'RESET_SIZE_INFO_INVOICE';

export const UPDATE_SIZE_INFO_MES_REQUEST = 'UPDATE_SIZE_INFO_MES_REQUEST';
export const UPDATE_SIZE_INFO_MES_SUCCESS = 'UPDATE_SIZE_INFO_MES_SUCCESS';
export const UPDATE_SIZE_INFO_MES_FAILURE = 'UPDATE_SIZE_INFO_MES_FAILURE';

export const CREATE_SIZE_INFO_MES_REQUEST = 'CREATE_SIZE_INFO_MES_REQUEST';
export const CREATE_SIZE_INFO_MES_SUCCESS = 'CREATE_SIZE_INFO_MES_SUCCESS';
export const CREATE_SIZE_INFO_MES_FAILURE = 'CREATE_SIZE_INFO_MES_FAILURE';


export const FETCH_SIZE_INFO_MES_REQUEST = 'FETCH_SIZE_INFO_MES_REQUEST';
export const FETCH_SIZE_INFO_MES_SUCCESS = 'FETCH_SIZE_INFO_MES_SUCCESS';
export const FETCH_SIZE_INFO_MES_FAILURE = 'FETCH_SIZE_INFO_MES_FAILURE';


export const FETCH_SIZE_INFO_MES_SINGLE_GET_REQUEST = 'FETCH_SIZE_INFO_MES_SINGLE_GET_REQUEST';
export const FETCH_SIZE_INFO_MES_SINGLE_GET_SUCCESS = 'FETCH_SIZE_INFO_MES_SINGLE_GET_SUCCESS';
export const FETCH_SIZE_INFO_MES_SINGLE_GET_FAILURE = 'FETCH_SIZE_INFO_MES_SINGLE_GET_FAILURE';